import { render, staticRenderFns } from "./ActHistoricDetailBtn.vue?vue&type=template&id=47eb5b00"
import script from "./ActHistoricDetailBtn.vue?vue&type=script&lang=js"
export * from "./ActHistoricDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports